import React, { useState, useEffect, useRef } from 'react';
import { Send } from 'lucide-react';
import telegramIcon from '../../assets/icons/telegram.svg';

// Импортируем все иконки категорий
import proxyIcon from '../../assets/icons/categories/proxy.svg';
import personalDataIcon from '../../assets/icons/categories/personal-data.svg';
import callIcon from '../../assets/icons/categories/call.svg';
import incognitoIcon from '../../assets/icons/categories/incognito.svg';
import documentsIcon from '../../assets/icons/categories/documents.svg';
import bankCardsIcon from '../../assets/icons/categories/bank-cards.svg';
import cubeIcon from '../../assets/icons/categories/cube.svg';
import userVerifiedIcon from '../../assets/icons/categories/user-verified.svg';
import searchIcon from '../../assets/icons/categories/search.svg';
import bankIcon from '../../assets/icons/categories/bank.svg';
import chatIcon from '../../assets/icons/categories/chat.svg';

// Маппинг имен иконок на импорты
const categoryIcons = {
    'proxy': proxyIcon,
    'personal-data': personalDataIcon,
    'call': callIcon,
    'incognito': incognitoIcon,
    'documents': documentsIcon,
    'bank-cards': bankCardsIcon,
    'cube': cubeIcon,
    'user-verified': userVerifiedIcon,
    'search': searchIcon,
    'bank': bankIcon,
    'chats': chatIcon,
};

const MAIN_CATEGORY_COLOR = ' #820486';

export const CategoryButton = ({ children, icon, type, active, color, ...props }) => {
    // Получаем иконку из маппинга или используем дефолтную
    const iconSrc = icon ? (categoryIcons[icon] || cubeIcon) : null;

    return (
        <button
            className="flex items-center gap-2 px-3 py-1 rounded-lg text-white font-manrope font-medium text-sm leading-[1.25em] transition-all duration-200"
            style={{
                backgroundColor: active ? '#FF00A7' : 'rgba(184, 118, 161, 0.3)',
                backdropFilter: 'blur(32px)',
                boxShadow: active
                    ? '0px 0px 32px 0px rgba(255, 0, 167, 0.5), 0px 0px 8px 0px rgba(255, 0, 167, 0.5)'
                    : 'none',
            }}
            onMouseEnter={(e) => {
                if (!active) {
                    // Градиент как в Figma для неактивной кнопки при ховере
                    e.currentTarget.style.background = 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.25) 100%)';
                }
            }}
            onMouseLeave={(e) => {
                if (!active) {
                    e.currentTarget.style.background = 'rgba(184, 118, 161, 0.3)';
                }
            }}
            {...props}
        >
            {iconSrc && <img src={iconSrc} alt="" className="w-3 h-3" />}
            {children && <span className="text-[14px]">{children}</span>}
        </button>
    );
};




export const LinkServiceButton = ({ variant, ...props }) => {
    const isFeatured = variant === 'featured';
    return (
        <button
            className="flex items-center gap-2 px-3 py-1 rounded-lg text-white font-manrope text-sm leading-[1.4285714285714286em] transition-all duration-200"
            style={
                isFeatured
                    ? {
                          background: '#FF00A7',
                          border: '1px solid #FF00A7',
                          boxShadow: '0 0 14px rgba(255, 0, 167, 0.9)',
                      }
                    : {
                          background: 'linear-gradient(180deg, rgba(255, 0, 167, 0) 0%, rgba(255, 0, 167, 0.5) 100%)',
                          border: '1px solid #FF00A7',
                      }
            }
            onMouseEnter={(e) => {
                e.currentTarget.style.background = isFeatured
                    ? '#ff2eb8'
                    : 'linear-gradient(180deg, rgba(255, 0, 167, 0.2) 0%, rgba(255, 0, 167, 0.7) 100%)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = isFeatured
                    ? '#FF00A7'
                    : 'linear-gradient(180deg, rgba(255, 0, 167, 0) 0%, rgba(255, 0, 167, 0.5) 100%)';
            }}
            {...props}
        >
            <img src={telegramIcon} alt="Telegram" className="w-3 h-3" />
            <span>Link</span>
        </button>
    );
};